module.exports = __webpack_public_path__ + "static/media/hall-PF.00589504.svg";